// removed by extract-text-webpack-plugin
module.exports = {"block":"TopMenuIconLink__block-2WYrk","icon":"TopMenuIconLink__icon-2Rohq","mark":"TopMenuIconLink__mark-1NMGC"};